"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const checkMail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const checkLogin = /^(?=.{4,30}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+$/;
const checkPasswordHard = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W\_])[a-zA-Z0-9\W\_]{8,100}$/;
const checkPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9\W\_]{8,}$/;
const checkNumber = /^\d+$/;
exports.default = { checkLogin, checkMail, checkPassword, checkPasswordHard, checkNumber };
//# sourceMappingURL=index.js.map